import React from "react";
import { IonCol, IonRow } from "@ionic/react";
import { capitalizeString } from "../../../utils/utils";
import { CardAsistencia, CardMensajeAviso, InputText, Titulo } from "app-principal-componentes-visuales";
import "./HistorialFinalizadas.scss"

const HistorialFinalizadas = ({ serviciosFinalizados, placeholder, isPrincipal, socio, casoFinalizadosOrdenados, casoFinalizadoPorFecha, errorFinalizadas, openSelectGrupoFamiliarModal, handleDetalleCaso }) => {
    return (
        <div className="historial-finalizadas">
            {errorFinalizadas ?
                <IonRow className="lista-atenciones-vacio">
                    <IonCol size='12'>
                        <CardMensajeAviso
                            alerta
                            id="asistencia-historial-vacio"
                            titulo="En este momento no podemos cargar el Historial de Asistencias Finalizadas"
                            texto="Intentá nuevamente más tarde."
                        />
                    </IonCol>
                </IonRow>
            :
                <>
                    <IonRow className='input-padding'>
                        <IonCol>
                            <InputText
                                id="datos-contacto-historial-input"
                                cambiarLink
                                label="¿De qué integrante?"
                                onClick={openSelectGrupoFamiliarModal}
                                type="text"
                                value={placeholder}
                                placeholder={placeholder}
                                disable={isPrincipal ?
                                    (socio.familiares.length > 0 ? false : true)
                                    : false}
                            />
                        </IonCol>
                    </IonRow>
                    { serviciosFinalizados.length === 0 ?
                        <>
                            <IonRow className="lista-atenciones-vacio">
                                <IonCol size='12'>
                                    <CardMensajeAviso
                                        alerta
                                        id="asistencia-historial-vacio"
                                        titulo="Usted no dispone de asistencias finalizadas en los últimos 30 días."
                                        texto="Intentá nuevamente más tarde."
                                    />
                                </IonCol>
                            </IonRow>
                        </>
                        :
                        <IonRow>
                            <IonCol size='12'>
                                {casoFinalizadosOrdenados.map((year) => (
                                    <div key={year}>
                                        <IonRow>
                                            <IonCol size='12'>
                                                <Titulo
                                                    fontXs
                                                    className='year'
                                                    titulo={year}
                                                    id="titulo-asistencia-year"
                                                />
                                            </IonCol>
                                        </IonRow>
                                        { casoFinalizadoPorFecha[year].map((servicioFinalizado) => {
                                            const fechaCreacion = new Date(servicioFinalizado.fechaCreacion);
                                            const mesActual = new Intl.DateTimeFormat('es-ES', { month: 'short' }).format(fechaCreacion);

                                            return (
                                                <IonRow key={servicioFinalizado.id}>
                                                    <IonCol>
                                                        <CardAsistencia
                                                            dia={fechaCreacion.getDate().toString()}
                                                            id="asistencia-medica-card-asistencia"
                                                            mes={mesActual}
                                                            turnos={[
                                                                {
                                                                    onClick: () => { handleDetalleCaso(servicioFinalizado) },
                                                                    especialidadPara: servicioFinalizado.descripcion,
                                                                    familiar: capitalizeString(servicioFinalizado.principal.apellidos + ' ' + servicioFinalizado.principal.nombre),
                                                                    prestador: capitalizeString(servicioFinalizado.prestador),
                                                                    verDetalle: true
                                                                }
                                                            ]}
                                                        />
                                                    </IonCol>
                                                </IonRow>
                                            );
                                        })}
                                    </div>
                                ))}
                            </IonCol>
                        </IonRow>
                    }
                </>
            }
        </div>
    )
}

export default HistorialFinalizadas